import { render, staticRenderFns } from "./editGift.vue?vue&type=template&id=b84e9e6a&scoped=true&"
import script from "./editGift.vue?vue&type=script&lang=js&"
export * from "./editGift.vue?vue&type=script&lang=js&"
import style0 from "./editGift.vue?vue&type=style&index=0&id=b84e9e6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84e9e6a",
  null
  
)

export default component.exports